import { Link, router, usePage } from '@inertiajs/react';
import { AppShell, Box, Burger, Button, Container, Group, Image, Modal, rem, Stack, Text, useMantineTheme } from '@mantine/core';
import { useCounter, useDisclosure, useMediaQuery } from '@mantine/hooks';
import { IconLogin2, IconUserCircle, IconUserFilled } from '@tabler/icons-react';
import { useEffect } from 'react';

import hisselitapuLogo from '@/images/logo.svg';
// import BookACallPopup from '@/pages/site/call-booking/BookACallPopup.jsx';
import SiteFooter from '@/pages/site/layouts/SiteFooter.jsx';

// import popup from './popup-10usd.png';
import classes from './SiteNav.module.css';

export default function SiteNav({ showFooter = true, bg = '#F8F8FF', children }) {
  const auth = usePage().props?.auth;

  // show popup when mouse leaves the page
  // const [popupState, popupStateHandler] = useCounter(0);
  //
  // useEffect(() => {
  //   const hasShown = sessionStorage.getItem('popupShown');
  //
  //   const popupHandler = e => {
  //     if (!hasShown && !e.toElement && !e.relatedTarget && !auth?.user && e.clientY < 1) {
  //       popupStateHandler.increment();
  //       sessionStorage.setItem('popupShown', 'true');
  //     }
  //   };
  //
  //   window.addEventListener('mouseout', popupHandler);
  //   return () => window.removeEventListener('mouseout', popupHandler);
  // }, [auth]);

  // Mantine AppShell
  const [opened, { toggle }] = useDisclosure();
  const collapseBreakpoint = 'md';
  const theme = useMantineTheme();

  // check mobile mantine way
  const isMobileS = useMediaQuery('(max-width: 374px)');

  // Close navbar if route changes
  useEffect(() => {
    return router.on('start', _event => {
      if (opened) {
        toggle();
      }
    });
  }, [opened]);

  const mpEnabled = import.meta.env?.VITE_MP_ENABLED;

  const links = (mobile = false) => (
    <>
      {auth?.roles?.includes('admin') && (
        <>
          <Link href={route('site.about')} className={classes.control}>
            HAKKIMIZDA
          </Link>
          <Link href={route('site.offers')} className={classes.control}>
            YATIRIM
          </Link>
          <Link href={route('site.marketplace')} className={classes.control}>
            PAZAR YERİ
          </Link>
        </>
      )}
      {/*<Link href={route('site.how-it-works')} className={classes.control}>*/}
      {/*  NASIL ÇALIŞIR*/}
      {/*</Link>*/}
      {/*<a href="https://blog.goldframer.com" className={classes.control}>*/}
      {/*  BLOG*/}
      {/*</a>*/}
      {mobile ? (
        <>
          <Link href={route('site.waitlist')} className={classes.control}>
            KAYIT OL
          </Link>
          {/*{!!auth?.user && (*/}
          {/*  <>*/}
          {/*    <Link href={route('site.earn')} className={classes.control}>*/}
          {/*      EARN $100*/}
          {/*    </Link>*/}
          {/*    <Link href={route('site.account.wallet')} className={classes.control}>*/}
          {/*      WALLET*/}
          {/*    </Link>*/}
          {/*  </>*/}
          {/*)}*/}
        </>
      ) : null}
    </>
  );

  return (
    <AppShell
      classNames={{
        root: classes.root,
        main: showFooter ? classes.main : classes.mainNoFooter,
        footer: classes.footer,
      }}
      header={{ height: theme.other.headerHeight }}
      navbar={{ width: 300, breakpoint: collapseBreakpoint, collapsed: { desktop: true, mobile: !opened } }}
    >
      <AppShell.Header>
        <Container>
          <Group h="100">
            <Burger opened={opened} onClick={toggle} hiddenFrom={collapseBreakpoint} size="sm" />
            <Group justify="space-between" style={{ flex: 1 }} wrap={'nowrap'} gap={0}>
              <Group gap={'xl'}>
                <Link href={'/'}>
                  <Image src={hisselitapuLogo} />
                </Link>

                <Group gap={0} visibleFrom={collapseBreakpoint}>
                  {links()}
                </Group>
              </Group>

              {/* Mobile Header */}
              <Group ml="xl" gap={0} hiddenFrom={collapseBreakpoint} wrap={'nowrap'}>
                {!!auth?.user && (
                  <Link href={route('site.account')} className={classes.control}>
                    <Group gap={'xs'} c="var(--color-gf)" wrap={'nowrap'}>
                      <IconUserCircle stroke={1.5} size={'1rem'} />{' '}
                      <Text c="var(--color-main)" size="inherit" hidden={isMobileS} lh={1} fz={'sm'}>
                        {auth?.user?.name}
                      </Text>
                    </Group>
                  </Link>
                )}
              </Group>

              {/* Header */}
              <Group ml="xl" gap={0} visibleFrom={collapseBreakpoint}>
                {!auth?.user && (
                  // <Group gap={'sm'}>
                  //   <Button variant="navy" size="lg" fw={600} component={Link} href={route('register')}>
                  //     Üye Ol
                  //   </Button>
                  //   <Button
                  //     size="lg"
                  //     fw={600}
                  //     fz={rem(14)}
                  //     variant="outline"
                  //     component={Link}
                  //     href={route('register')}
                  //     c={'navy'}
                  //   >
                  //     Giriş Yap
                  //   </Button>
                  // </Group>

                  <Group gap={'sm'}>
                    <Button variant="navy" size="lg" fw={600} component={Link} href={route('site.waitlist')}>
                      Kayıt Ol
                    </Button>
                  </Group>
                )}

                {!!auth?.user && (
                  <>
                    {/*<Button*/}
                    {/*  component={Link}*/}
                    {/*  href={route('site.earn')}*/}
                    {/*  variant="outline"*/}
                    {/*  color="yellow"*/}
                    {/*  radius="xs"*/}
                    {/*  c={'gfdark.9'}*/}
                    {/*  mr={'sm'}*/}
                    {/*  fw={500}*/}
                    {/*  size="xs"*/}
                    {/*>*/}
                    {/*  EARN $100*/}
                    {/*</Button>*/}

                    <Link href={route('site.account.wallet')} className={classes.control}>
                      CÜZDAN
                    </Link>

                    <Link href={route('site.account')} className={classes.control}>
                      <Group gap={5}>
                        <IconUserFilled stroke={2} size={'1rem'} />
                        <Text size={'md'} fw={500}>
                          {auth?.user?.name}
                        </Text>
                      </Group>
                    </Link>
                  </>
                )}
              </Group>
            </Group>
          </Group>
        </Container>
      </AppShell.Header>

      {/* Mobile Nav */}
      <AppShell.Navbar py="md" px={'lg'}>
        <Stack align="stretch" justify="space-between" h={'100%'} fz={'xl'}>
          <div>{links(true)}</div>
          <div>
            {/*{!auth?.user && (*/}
            {/*  <Group justify={'space-between'}>*/}
            {/*    <Link href={route('register')} className={classes.control}>*/}
            {/*      <Text fz={'inherit'} c={'gf'}>*/}
            {/*        ÜYE OL*/}
            {/*      </Text>*/}
            {/*    </Link>*/}
            {/*    <Link href={route('login')} className={classes.control}>*/}
            {/*      <Group gap={'xs'} c="var(--color-gf)">*/}
            {/*        <IconLogin2 />{' '}*/}
            {/*        <Text c="gfdark.9" fz="inherit">*/}
            {/*          GİRİŞ YAP*/}
            {/*        </Text>*/}
            {/*      </Group>*/}
            {/*    </Link>*/}
            {/*  </Group>*/}
            {/*)}*/}
            {/*{!!auth?.roles?.includes('admin') && (*/}
            {/*  <>*/}
            {/*    <Link href="/panel" className={classes.control}>*/}
            {/*      PANEL*/}
            {/*    </Link>*/}
            {/*  </>*/}
            {/*)}*/}
            {/*{!!auth?.user && (*/}
            {/*  <>*/}
            {/*    <a href="/logout" className={classes.control}>*/}
            {/*      ÇIKIŞ*/}
            {/*    </a>*/}
            {/*  </>*/}
            {/*)}*/}
          </div>
        </Stack>
      </AppShell.Navbar>

      <AppShell.Main bg={bg}>
        {children}

        {/*<Modal*/}
        {/*  withCloseButton={false}*/}
        {/*  padding={0}*/}
        {/*  radius={'lg'}*/}
        {/*  size={'auto'}*/}
        {/*  opened={popupState === 1}*/}
        {/*  onClose={popupStateHandler.increment}*/}
        {/*  centered*/}
        {/*>*/}
        {/*  <Link href={route('register')}>*/}
        {/*    <Image src={popup} maw={700} />*/}
        {/*  </Link>*/}
        {/*</Modal>*/}

        {/* Book a Call */}
        {/*{!opened && <BookACallPopup showFooter={showFooter} />}*/}
      </AppShell.Main>

      {showFooter && (
        <AppShell.Footer withBorder={false}>
          <SiteFooter />
        </AppShell.Footer>
      )}
    </AppShell>
  );
}
